import ComingSoon from '../../components/CommingSoon/CommingSoon';
import ProgressCard from '../../components/Piano Turistico/ProgressCard/ProgressCard'
import ProgressList from '../../components/Piano Turistico/ProgressCard/ProgressList'
import styles from './Arrivi.module.css'
import Footer from '../../components/common/Footer/Footer';
import ChartBox from '../../components/ArriviGraph/GraphBox'
import React, { useEffect, useState } from 'react';
import Catania from '../../assets/images/Catania.jpg'
import Messina from '../../assets/images/Messina.jpg'
import Agro from '../../assets/images/Valle.jpg'
import Cass from '../../assets/images/Cass.jpg'
const Data = () => {


  const [events, setEvents] = useState([
    {
      date: new Date('2023-09-01'),
      name: 'Regatta Storica',
      description: '',
      location: 'Venice, Veneto'
  },  
  {
      date: new Date('2023-09-07'),
      name: 'Festa della Rificolona',
      description: 'An historical event celebrating the birthday of the Virgin Mary. A colourful parade with homemade paper lanterns on sticks',
      location: 'Florence, Tuscany'
  },
  {
      date: new Date('2023-09-19'),
      name: 'Festival San Gennaro',
      description: '',
      location: 'Naples, Campania'
  },
  {
      date: new Date('2023-11-01'),
      name: "Tutti I Santi or Ogniss",
      description: '',
      location: 'National Public Holiday'
  },
  {
      date: new Date('2023-12-08'),
      name: 'Immacolata Concezione',
      description: '',
      location: 'National Public Holiday'
  },
  {
      date: new Date('2023-12-25'),
      name: 'Natale',
      description: '',
      location: 'National Public Holiday'
  },
  {
      date: new Date('2023-12-26'),
      name: "Santo Stefano",
      description: '',
      location: ''
  }
]);
  

  const [closestEvent, setClosestEvent] = useState(null);

  useEffect(() => {
    findClosestEvent();
  }, [events]);

  const findClosestEvent = () => {
    const today = new Date();

    const sortedEvents = events.sort((a, b) => Math.abs(today - a.date) - Math.abs(today - b.date));
    setClosestEvent(sortedEvents[0]);
  };


    return (
      <div className={styles.container}>
     
     <ProgressCard  title={'Arrivi'} values={'Arrivi (visite)'}>
      <ProgressList fontSize={'12px'} img={Catania} place={'Prov. Catania (media mensile 2022)'} value={438788} color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753}/> 
     <ProgressList fontSize={'12px'}
  img={Messina}
  place={'Prov. Messina (media mensile 2022)'}
  value={383965} // Passed as a number
  color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753} // Passed as a number
/>
       
        {/* <ProgressList img={Agro} place={"Valle d'Agrò (2022)"} value={153324} color={'rgba(110, 160, 43, 0.5)'}
  total_value={2000000}/>  */}
       <ProgressList fontSize={'12px'} img={Cass} place={'Area CIRCE (media mensile 2023)'} value={26354} color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753}/> 
     </ProgressCard>
     <ProgressCard title={'Visite'} >
     <ChartBox></ChartBox>
     </ProgressCard>


      <Footer></Footer>
      </div>
  );
}

export default Data; 
